import { eventDateGridFormatter } from "@/utils/dates";


/**
 * Cell renderer for displaying sale dates
 * Handles both new and existing sale dates, and special cases like "now"
 */
const SalesDateCell = (params) => {
  const formatSaleDate = (saleDate) => {
    // Handle special case for "now"
    if (saleDate === "now") return "NOW";
    else if (saleDate === "IsMonitor") return "Monitor For Drops";
    else if (saleDate === "IsTraining") return "TRAINING";
    // Handle sale date objects with type
    if (typeof saleDate === 'object' && saleDate.saleDate) {
      try {
        // do not use saleDate.saleDate + 'Z' here if the date is already in UTC
        const dateStr = saleDate.saleDate?.endsWith('Z') ? saleDate.saleDate : saleDate.saleDate + 'Z';
        return eventDateGridFormatter(new Date(dateStr));
      } catch (error) {
        console.error("Error formatting sale date object: ", error, saleDate);
        return "ERROR";
      }
    }

    // Handle string dates
    if (saleDate) {
      try {
        // Check if the date string has a timezone offset (like +00:00 or -03:00)
        const hasOffset = /[+-]\d{2}:?\d{2}$/.test(saleDate);
        // Only add Z if there's no offset and doesn't already end with Z
        const dateStr = hasOffset ? saleDate : (saleDate?.endsWith('Z') ? saleDate : saleDate + 'Z');
        const date = new Date(dateStr);
        let formattedDate;
        if(date.toString() === "Invalid Date" ){
          console.error("Error formatting sale date date: ", date);
          console.error("Error formatting sale date dateStr: ", dateStr);
          console.error("Error formatting sale date saleDate: ", saleDate);
          formattedDate = "Invalid Date";
        }else{
          formattedDate = eventDateGridFormatter(date);
        }
        return formattedDate;
      } catch (error) {
        console.error("Error formatting sale date: ", error);
        return "ERROR";
      }
    }

    return "";
  };

  return (
    <div>
        <span>{formatSaleDate(params.value)}</span>
    </div>
  );
};

export default SalesDateCell;